module.exports = __webpack_public_path__ + "img/military_base-blurred.ae4b18ff.jpg";